import { Box, Grid, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";
import PlaceIcon from '@mui/icons-material/Place';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import StarBorderIcon from '@mui/icons-material/StarBorder';
import { useWindowSize } from "../hooks/useWindowSize";

export default function Marketing1() {

    const { t } = useTranslation();

    const { isMobile, isTablet } = useWindowSize();

    const IconCircle = ({ children }) => (
        <Box sx={{
            width: isMobile ? 60 : isTablet ? 70 : 80,
            height: isMobile ? 60 : isTablet ? 70 : 80,
            borderRadius: '50%',
            // backgroundColor: 'rgba(255, 255, 255, 0.3)',
            // backgroundColor: 'rgba(255, 107, 53, 1)', //v#EF7C4F
            backgroundColor: '#EF7C4F',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto'
        }}>
            {children}
        </Box>
    );

    return (
        <Box className="marketing1">
            <Box className="marketing1-content">
                <Box className="maketing1-header">
                    <Typography variant={isMobile ? "h4" : isTablet ? "h3" : "h2"}  component="h2" sx={{ textAlign: 'center', paddingBottom: 2, color: 'white', fontWeight: 'bold' }}>
                        {t('marketing1.headerText')}
                    </Typography>
                    <Box sx={{
                        width: isMobile ? '160px' : '280px',
                        height: '3px',
                        backgroundColor: 'white',
                        margin: '16px auto 32px auto',
                        borderRadius: '2px',
                    }}></Box>
                </Box>
                <Box className="marketing1-text" sx={{ maxWidth: 800, margin: '0 auto' }}>
                    <Typography variant="body1" component="p" sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.9)', paddingLeft: 2, paddingRight: 2 }}>
                        {t('marketing1.subHeaderText')}
                    </Typography>
                </Box>
                <Grid container spacing={2} className="marketing1-list">
                    <Grid size={{xs: 12, sm: 4, md: 4, lg: 4}} className="marketing1-list-item">
                        <IconCircle>
                            <PlaceIcon style={{ color: 'white', fontSize: isMobile ? '2rem' : isTablet ? '2.5rem' : '3rem' }} />
                        </IconCircle>
                        <Typography variant="h6" component="p" sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.9)', marginTop: 2 }}>
                            {t('marketing1.icon1Text')}
                        </Typography>
                        <Typography variant="body2" component="p" sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.7)', marginTop: 1 }}>
                            {t('marketing1.icon1SubText')}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 12, sm: 4, md: 4, lg: 4}} className="marketing1-list-item">
                        <IconCircle>
                            <CalendarTodayIcon style={{ color: 'white', fontSize: isMobile ? '2rem' : isTablet ? '2.5rem' : '3rem' }} />
                        </IconCircle>
                        <Typography variant="h6" component="p" sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.9)', marginTop: 2 }}>
                            {t('marketing1.icon2Text')}
                        </Typography>
                        <Typography variant="body2" component="p" sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.7)', marginTop: 1 }}>
                            {t('marketing1.icon2SubText')}
                        </Typography>
                    </Grid>
                    <Grid size={{xs: 12, sm: 4, md: 4, lg: 4}} className="marketing1-list-item">
                        <IconCircle>
                            <StarBorderIcon style={{ color: 'white', fontSize: isMobile ? '2rem' : isTablet ? '2.5rem' : '3rem' }} />
                        </IconCircle>
                        <Typography variant="h6" component="p" sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.9)', marginTop: 2 }}>
                            {t('marketing1.icon3Text')}
                        </Typography>
                        <Typography variant="body2" component="p" sx={{ textAlign: 'center', color: 'rgba(255, 255, 255, 0.7)', marginTop: 1 }}>
                            {t('marketing1.icon3SubText')}
                        </Typography>
                    </Grid>
                </Grid>
            </Box>
        </Box>
    )
}